
<div>
  <input class="d-none" type="file" ref="file" @change="uploadAttachment()" />
  <button class="btn btn-block btn-info" @click.prevent="addAttachment()" :class="{ 'btn-sm': isSmallButton }">
    <i class="far fa-file icon-left mr-2"></i>
    {{ label ? label : 'Attachment' }}
  </button>
  <!-- </div> -->
</div>
